import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, Home, Menu as MenuIcon } from "lucide-react";
import { useContent } from "@/lib/ContentProvider";

/**
 * BackToMenuButton — pastille flottante en bas à droite sur toutes les pages
 * publiques internes accessibles depuis le Menu.
 *
 * Configurable depuis Admin → Site web → Accueil :
 *   content.menuBackButton = { visible: bool, label: str, icon_key: "arrow"|"home"|"menu" }
 */
const ICON_MAP = {
  arrow: ArrowLeft,
  home: Home,
  menu: MenuIcon,
};

const DEFAULTS = {
  visible: true,
  label: "Retour au menu",
  icon_key: "arrow",
};

export default function BackToMenuButton() {
  const { pathname } = useLocation();
  const { content } = useContent() || {};
  // Sur le Menu même : rien.
  if (pathname === "/accueil") return null;

  const cfg = { ...DEFAULTS, ...(content?.menuBackButton || {}) };
  if (cfg.visible === false) return null;

  const Icon = ICON_MAP[cfg.icon_key] || ArrowLeft;
  const label = (cfg.label || DEFAULTS.label).trim() || DEFAULTS.label;

  return (
    <Link
      to="/accueil"
      data-testid="back-to-menu"
      aria-label={label}
      className="fixed z-[70] inline-flex items-center gap-2 rounded-full text-[12px] md:text-[13px] font-body tracking-wide select-none focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--cr-ruby)]/40 transition-all duration-500 hover:scale-[1.04]"
      style={{
        right: "calc(env(safe-area-inset-right, 0px) + 14px)",
        bottom: "calc(env(safe-area-inset-bottom, 0px) + 14px)",
        padding: "8px 16px 8px 12px",
        background: "rgba(255, 253, 249, 0.94)",
        color: "var(--cr-ink)",
        border: "1px solid rgba(139, 37, 48, 0.28)",
        boxShadow: "0 4px 14px rgba(46, 31, 24, 0.10)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
      }}
    >
      <Icon size={14} strokeWidth={1.4} style={{ color: "var(--cr-ruby)" }} />
      <span>{label}</span>
    </Link>
  );
}
